const React = require('react');
const Emitter = require('mn-utils/Emitter');
const CancelablePromise = require('mn-utils/CancelablePromise');
const trim = require('mn-utils/trim');
const loopMap = require('mn-utils/loopMap');
const map = require('mn-utils/map');
const get = require('mn-utils/get');
const LayoutB = require('../../../dumb/Layout/B');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const ButtonA = require('../../../dumb/Button/A');
const Ripple = require('../../../dumb/Ripple');
const TextFieldReg = require('../../../dumb/TextField/Reg');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading');
const withState = require('../../../../utils/withState');
const {paramStore} = require('../../../../stores');

const NAV_ITEMS = loopMap(13, (i) => {
  return {
    id: '' + i,
    name: 'Other organisation ' + i,
  };
}, [
  {
    id: 'gmbh',
    name: 'Lunu Solutions GmbH',
  },
], 1);
function loopMapIteratee(i) {
  return {
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing tortor.',
    host: i % 2 > 0,
  };
}

const MESSAGES_MAP = {
  'gmbh': loopMap(1, loopMapIteratee),
  '1': loopMap(3, loopMapIteratee),
  '2': loopMap(5, loopMapIteratee),
  '3': loopMap(2, loopMapIteratee),
  '4': loopMap(12, loopMapIteratee),
};


function getMessages(params) {
  loadingDialogs$.emit(1);
  const id = '' + (params.id || 0);
  return CancelablePromise.delay(500, {
    list: MESSAGES_MAP[id] || [],
  }).finally(loadingDialogs$.bind(1));
}

const loadingDialogs$ = new Emitter(0);
const dialogs$ = new Emitter(NAV_ITEMS);
const activeId$ = paramStore('id', 0);
const messages$ = new Emitter([]);
const cache = {};

function updateMessages(id) {
  messages$.emit(cache[id = '' + id] || []);
  return getMessages({id}).then((v) => {
    messages$.emit(cache[id] = v.list);
  });
}

module.exports = withState((setState) => {
  let _node;
  let _activeId;
  function handleChangeAnswer(e) {
    setState({
      answer: e.target.value,
    });
  }
  function onRef(node) {
    _node = node;
  }
  return (state) => {
    const {
      clicked,
    } = state;
    const dialogs = state.dialogs || [];
    const activeId = '' + (state.activeId || get(dialogs, '0.id'));
    const answer = state.answer || '';
    const invalidAnswer = !trim(answer);

    _activeId === activeId || updateMessages(_activeId = activeId);

    function handleSend() {
      setState({
        loadingSend: 1,
      });
      return CancelablePromise
          .delay(500)
          .finally((error) => {
            const items = MESSAGES_MAP[activeId]
              || (MESSAGES_MAP[activeId] = []);
            error || items.push({
              id: '' + (items.length + 1),
              content: answer,
              host: 1,
            });
            setState({
              loadingSend: 0,
              answer: error ? answer : '',
            });
            error || updateMessages(activeId).finally(() => {
              _node && _node.scrollTo(0, _node.scrollHeight || 0);
            });
          });
    }

    return (
      <LayoutB>
        <HeaderA>
          <CaptionA>Help</CaptionA>
        </HeaderA>
        <div className="w hmin300 h100vh-340 rlv bs bcF2 b2 ov r8">
          <div className="abs svl15 w200 bg02 ovx ovyA r8">
            {map(dialogs, (v) => {
              const {id} = v;
              return (
                <Ripple
                  className={`h40 w layoutRow fvaC ph15 ov tov ws dn
                    bg02(:h|.active) ` + (id === activeId ? 'active' : '')}
                  onClick={activeId$.bind(id)}
                >{v.name}</Ripple>
              );
            }, [])}
          </div>
          <div
            className="abs sl215 svr ovx ovyA"
            ref={onRef}
          >
            <WrapperWithLoading
              className="sq pv15 ph25"
              loading={state.loading}
            >
              {map(state.messages, (message) => {
                return (
                  <div className="cfx">
                    <div
                      className={`p15 rlv bs b2 bc02 bg02 r5 mb15 w3/4 rt.host
                    (dB|sq1|bs|b10|bc00|abs|st50%|xY-50%|cnt'_'):(after|before)
                        (bcr36383b|sl-20):not[.host]:after
                        (bcr2f3133|b11|sl-24):not[.host]:before
                        (bcl36383b|sr-20).host:after
                        (bcl2f3133|b11|sr-24).host:before
                      ` + (message.host ? ' host' : '')}
                    >{message.content}</div>
                  </div>
                );
              }, [])}
            </WrapperWithLoading>
          </div>
        </div>
        <WrapperWithLoading
          className="mt15"
          loading={state.loadingSend}
        >
          <div className="layoutRow fhaS fvaC">
            <TextFieldReg
              error={clicked && invalidAnswer}
              placeholder="Answer"
              className="w"
              multiline
              rows={4}
              value={answer}
              onChange={handleChangeAnswer}
            />
            <ButtonA
              disabled={invalidAnswer}
              className="ml15 o50.disabled"
              onClick={handleSend}
            >Send</ButtonA>
          </div>
        </WrapperWithLoading>
      </LayoutB>
    );
  };
}, {
  activeId: activeId$,
  messages: messages$,
  dialogs: dialogs$,
  loading: loadingDialogs$,
});
